import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function ForwardIcon(props: IconProps) {
    return <Icon {...props} iconKey={"forward"}/>
}
